import { useId, useState } from 'react';
import { ReactComponent as ChevronDown } from 'src/assets/chevron_down.svg';
import { ReactComponent as ChevronUp } from 'src/assets/chevron_up.svg';
import Filters from 'src/components/form/filters/filters';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import CheckboxGroup from 'src/components/form/search/filters-popup/checkbox-group';
import { EventsFilterProps } from 'src/types/events';
import EventsCalendar from '../calendar/calendar';
import css from '../events.module.scss';

export default function EventsFilters({
  onSubmit,
  locations,
  initialValues,
  currentDate
}: Readonly<EventsFilterProps>) {
  const [locationsOpen, setLocationsOpen] = useState(false);

  const inputId = useId();

  return (
    <Filters
      initialFilters={initialValues}
      onSearch={onSubmit}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search', 'locationId']}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.filtersGroup}>
          <div className={css.inputSearch}>
            <SearchInput
              id={inputId}
              name='search'
              placeholder='Шукати подію'
              error={errors?.search?.message}
              inputProps={registerAndClearOnChange('search')}
            />
          </div>

          <EventsCalendar currentDate={currentDate} onDateSelect={onSubmit} />

          {locations.length > 0 && (
            <div className={css.locations}>
              <button className={css.locationsHeader} onClick={() => setLocationsOpen((prev) => !prev)}>
                <div className={css.title}>Місце проведення</div>
                {locationsOpen ? <ChevronUp /> : <ChevronDown />}
              </button>
              {locationsOpen && (
                <div className={css.locationsContent}>
                  <CheckboxGroup entities={locations} name='locationId' title='' />
                </div>
              )}
            </div>
          )}
        </div>
      )}
    />
  );
}
